<template>
  <td :class="[
    'p-3 whitespace-nowrap',
    !noTextColor && 'text-gray-700 dark:text-gray-200',
    customClass
  ]" :colspan="colspan">
    <slot></slot>
  </td>
</template>

<script>
export default {
  name: 'TableCell',
  props: {
    noTextColor: {
      type: Boolean,
      default: false
    },
    colspan: {
      type: Number,
      default: 1
    },
    customClass: {
      type: String,
      default: ''
    }
  }
}
</script>
